export default {
  appName: 'vanish',
  appVersion: '2.2.23',
  isGenericVersion: true,
  appIcon: require('./logo.png'),
  backgroundImg: require('./bg.jpg')
}



// WEBPACK FOOTER //
// ./src/appInfo/vanish/appinfo.js